var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFanzNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 97,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#052C3F",
  d: "M75.31 9.766c-4.061.155-7.215 3.622-7.215 7.687v7.86c0 .191.152.343.342.343h2.97c.19 0 .342-.152.342-.342v-8.046a3.86 3.86 0 0 1 4.117-3.845c2.044.136 3.589 1.93 3.589 3.98v7.91c0 .191.152.343.342.343h2.97c.19 0 .342-.152.342-.342v-8.046c-.003-4.236-3.53-7.662-7.798-7.502"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#052C3F",
  fillRule: "evenodd",
  d: "M41.698 25.75a.443.443 0 0 1-.443-.442L41.244 9.03a6.23 6.23 0 0 1 6.22-6.219l1.743.001v.002h2.714v.132a3.56 3.56 0 0 1-1.049 2.512 3.59 3.59 0 0 1-2.52 1.046h-.348l-.001.003h-.537a2.54 2.54 0 0 0-2.526 2.526v.99h4.103v.132a3.56 3.56 0 0 1-1.049 2.512 3.59 3.59 0 0 1-2.52 1.046h-.532l.004 11.593a.443.443 0 0 1-.442.442z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#052C3F",
  d: "M96.83 25.202a.456.456 0 0 1-.456.454h-8.19c-.878 0-2.098-.959-2.098-2.3.095-.881-.391-1.038.07-1.765l5.872-8.177h-3.73a.456.456 0 0 1-.444-.352l-.641-2.739a.456.456 0 0 1 .444-.56h6.628c-.026 0 2.292.738 2.292 2.16-.007.712.213 1.276-.243 1.823l-5.952 8.252h6.007c.253 0 .458.205.456.458z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 88.136,
  cy: 23.141,
  r: 2.515,
  fill: "#052C3F"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 94.298,
  cy: 12.278,
  r: 2.515,
  fill: "#052C3F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#052C3F",
  fillRule: "evenodd",
  d: "M88.445 13.409h-.728a3.54 3.54 0 0 1-2.49-1.033 3.52 3.52 0 0 1-1.036-2.481v-.131h4.254zM49.35 17.757c0-4.407 3.587-7.994 7.994-7.994 4.408 0 7.994 3.587 7.994 7.994v7.56q0 .019-.002.037v.397h-.173a4.65 4.65 0 0 1-3.44-1.54l-.04-.015c-1.166 1-2.74 1.555-4.339 1.555-4.407 0-7.994-3.586-7.994-7.994m3.654 0a4.345 4.345 0 0 0 4.34 4.34 4.345 4.345 0 0 0 4.34-4.34 4.345 4.345 0 0 0-4.34-4.34 4.345 4.345 0 0 0-4.34 4.34",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#FanzNew_svg__a)",
  fillRule: "evenodd",
  d: "M25.035 0c-2.363 0-4.53.835-6.225 2.225l-1.363 1.362-.016.02-.002-.002-.95.95a3.87 3.87 0 0 0 0 5.443l.507.508 4.419-4.418.142.143a5.43 5.43 0 0 1 1.576 3.836 5.46 5.46 0 0 1-1.589 3.84l-.57.571 6.639 6.63 3.83-3.84a9.8 9.8 0 0 0 3.42-7.45C34.854 4.397 30.459 0 25.036 0",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#052C3F",
  fillRule: "evenodd",
  d: "m12.494 13.976 11.135 11.11-2.807 2.815a4.39 4.39 0 0 1-3.39 1.597 4.39 4.39 0 0 1-3.497-1.732L3.415 17.262A9.8 9.8 0 0 1 0 9.82C0 4.396 4.396 0 9.819 0c.986 0 1.938.145 2.836.416l-.161.162a9.49 9.49 0 0 0 0 13.398",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "FanzNew_svg__a",
  x1: 25.106,
  x2: 25.106,
  y1: 0,
  y2: 21.108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43CCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#47A1DA"
})))));
export { SvgFanzNew as ReactComponent };
export default __webpack_public_path__ + "FanzNew.1fa3fe29.svg";